import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import readMore from 'vue2-read-more'
import App from './App.vue'
import './plugins/notification'
import snackbarPlugin from './plugins/snackbar'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import i18n from './plugins/i18n';
import "@/utils/mixins";
Vue.use(snackbarPlugin, { store })

Vue.use(VueClipboard)
Vue.use(readMore)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app')
